import React, { useEffect, useState } from "react";
import { TOPIC } from "@utilitywarehouse/tracking-core";
import { TrackingProvider as ReactTrackingProvider } from '@utilitywarehouse/tracking-react';

import snowplowTracker from "../../snowplow/tracker";

const TrackingProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snowplowSessionStarted, setSnowplowSessionStarted] = useState(false);

  useEffect(() => {
    //starting snowplow session with authuser
    // userID is left undefined as the account number is set in the event itself
    snowplowTracker.startSession(undefined);

    return () => snowplowTracker.resetSession();
  }, []);
  
  snowplowTracker.subscribe(TOPIC.SESSION_START, () => {
    setSnowplowSessionStarted(true);
  });

  if (!snowplowSessionStarted) {
    return null;
  }

  return <ReactTrackingProvider client={snowplowTracker}>{children}</ReactTrackingProvider>;
};

export default TrackingProvider;